import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Plugins } from '@capacitor/core';
const { Browser } = Plugins;

@Component({
  selector: 'app-fmd-status-modal',
  templateUrl: './fmd-status-modal.page.html',
  styleUrls: ['./fmd-status-modal.page.scss'],
})


export class FmdStatusModalPage implements OnInit {

  public fmd_result: string;
  public submitted_dt: string;
  public name: string;
  constructor(
    public modalCtrl: ModalController,
  ) { }

  ngOnInit() {
    
  }

  async openPage(url) {
    if (url) {
      await Browser.open({ url: url });
    }
  }

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalCtrl.dismiss({
      'dismissed': true
    });
  }

}
